export default __webpack_public_path__ + "Kuantum3.pdf";